/**
 * Created by Junhua on 2017/5/3.
 * 所有的过滤器写在这里
 */
export default {
    formatDate: function (date,fmt) {//日期格式化
        // var fmt = 'yyyy-MM-dd hh:mm:ss'
        if(!date) return '';
        var date = new Date(date);
        var o = {
            "M+": date.getMonth() + 1, //月份
            "d+": date.getDate(), //日
            "h+": date.getHours(), //小时
            "m+": date.getMinutes(), //分
            "s+": date.getSeconds(), //秒
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度
            "S": date.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    },
    getPromType: function (value) {
        if(value == 0){
            return "普通";
        }else if(value == 1){
            return "直降";
        }else if(value == 2){
            return "满减";
        }else return '其他'
    },
    goodsState: function (value) {
        if(value == '0'){
            return "已下架";
        }else if(value == '1'){
            return "已上架";
        }else return '其他'
    },
    actState: function (value) {
        if(value == '0'){
            return "进行中";
        }else if(value == '1'){
            return "已完成";
        }else if(value == '2'){
            return "已过期";
        }else return '其他'
    },
    role: function (value) {
        if(value == '0'){
            return "管理员";
        }else return '其他'
    },
    couponState: function (value) {
        if(value == '0'){
            return "已下架";
        }else if(value == '1'){
            return "已上架";
        }else return '其他'
    },
    couponType: function (value) {
        if(value == 0){
            return "折扣券";
        }else if(value == 1){
            return "直降券";
        }else return '其他'
    },
    orderState: function (value) {
        if(value == 0){
            return "未支付";
        }else if(value == 1){
            return "已支付";
        }else if(value == 2){
            return "已完成";
        }else if(value == 3){
            return "已退款";
        }else if(value == 4){
            return "已取消";
        }else if(value == 5){
            return "未支付";
        }else return '其他'
    },
    txState: function (value) {
        if(value == '0'){
            return "待审";
        }else if(value == '1'){
            return "审批通过";
        }else if(value == '2'){
            return "审批拒绝";
        }else return '其他'
    },
}
